import gql from "graphql-tag";

export const REQUEST_LOW_TAX_BROKER_PAYOUT = gql`
  mutation RequestLowTaxBrokerPayOut($brokerageAccountId: ID!, $amount: Float!) {
    requestLowTaxBrokerPayOut(brokerageAccountId: $brokerageAccountId, amount: $amount) {
      feedback
    }
  }
`;
